/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IClientReactionsToOffer } from './ClientReactionsToOffer';
import type { IBargainTermsForDesktop } from './BargainTermsForDesktop';
import type { IGeoForDesktop } from './GeoForDesktop';
import type { IOfferLabel } from './OfferLabel';
import type { IComparisonStatusInfo } from '../comparison_status_info/ComparisonStatusInfo';
import type { IAgent } from '../agent/Agent';
import type { IFlatInfo } from './FlatInfo';
import type { ISuburbanInfo } from './SuburbanInfo';
import type { ICommercialInfo } from './CommercialInfo';
import type { IJKInfo } from './JKInfo';
import type { IModerationInfoForDesktop } from '../moderation_info/ModerationInfoForDesktop';
import type { ICommercialOwnership } from '../commercial_ownership/CommercialOwnership';
import type { IExtendedData1 } from '../extended_data/ExtendedData1';
import type { INewbuildingDynamicCalltracking } from '../newbuilding_dynamic_calltracking/NewbuildingDynamicCalltracking';

export interface IFavoriteEntityForDesktop {
  clientReactions: IClientReactionsToOffer;
  /** Realty Id объекта (объявка/ЖК) **/
  entityId: number;
  /** Тип объекта (объявка/ЖК) **/
  entityType: EEntityType;
  /** Тип сделки **/
  dealType: EDealType;
  /** Заголовок объекта **/
  title: string;
  /** Ссылка на объект **/
  fullUrl: string;
  bargainTerms: IBargainTermsForDesktop;
  geo: IGeoForDesktop;
  /** Лейблы **/
  labels: IOfferLabel[];
  /** Cian ID объявления **/
  entityCianId?: TFavoriteEntityForDesktop_EntityCianId;
  /** Статус **/
  status?: TFavoriteEntityForDesktop_Status;
  /** URL исходного изображения **/
  photoFullUrl?: TFavoriteEntityForDesktop_PhotoFullUrl;
  /** URL превью изображения **/
  photoPreviewUrl?: TFavoriteEntityForDesktop_PhotoPreviewUrl;
  /** Описание **/
  description?: TFavoriteEntityForDesktop_Description;
  /** Дата когда объявление удалится, только для снятых с публикации **/
  deleteDate?: TFavoriteEntityForDesktop_DeleteDate;
  /** Телефон **/
  phone?: TFavoriteEntityForDesktop_Phone;
  /** ИД категории для определния типа жалоб **/
  categoryComplaintId?: TFavoriteEntityForDesktop_CategoryComplaintId;
  /** Текст заметки **/
  note?: TFavoriteEntityForDesktop_Note;
  /** Статус добавления объекта в сравнение **/
  comparisonStatus?: TFavoriteEntityForDesktop_ComparisonStatus;
  /** Информация об агенте **/
  agentInfo?: TFavoriteEntityForDesktop_AgentInfo;
  /** Информация о жилой недвижимости **/
  flatInfo?: TFavoriteEntityForDesktop_FlatInfo;
  /** Информация о загородной недвижимости **/
  suburbanInfo?: TFavoriteEntityForDesktop_SuburbanInfo;
  /** Информация о коммерческой недвижимости **/
  commercialInfo?: TFavoriteEntityForDesktop_CommercialInfo;
  /** Информация о ЖК **/
  jkInfo?: TFavoriteEntityForDesktop_JkInfo;
  /** Проверено ли объявление в росреестре **/
  isRosreestrCheckSuccess?: TFavoriteEntityForDesktop_IsRosreestrCheckSuccess;
  /** Показывать ли предупреждение о недопустимости предоплаты **/
  showWarningMessage?: TFavoriteEntityForDesktop_ShowWarningMessage;
  /** Данные модерации **/
  moderationInfo?: TFavoriteEntityForDesktop_ModerationInfo;
  /** Данные о собственнике коммерческой недвижимости **/
  commercialOwnership?: TFavoriteEntityForDesktop_CommercialOwnership;
  /** Предпочитаемый тип связи **/
  communicationType?: TFavoriteEntityForDesktop_CommunicationType;
  /** Заголовок объекта для мобильного сайта **/
  titleForMobileSite?: TFavoriteEntityForDesktop_TitleForMobileSite;
  /** Является ли объявление партнерским **/
  isCianPartner?: TFavoriteEntityForDesktop_IsCianPartner;
  /** Ссылка на объявление на партнерском сайте **/
  externalOfferUrl?: TFavoriteEntityForDesktop_ExternalOfferUrl;
  /** Ссылка на платформу электронных торгов **/
  tradingLink?: TFavoriteEntityForDesktop_TradingLink;
  /** Дополнительные данные для объявлений посутки **/
  dailyrent?: TFavoriteEntityForDesktop_Dailyrent;
  /** Бронь от застройщика **/
  isBookedFromDeveloper?: TFavoriteEntityForDesktop_IsBookedFromDeveloper;
  /** Флаг, что объявление от продавца **/
  isFromSeller?: TFavoriteEntityForDesktop_IsFromSeller;
  /** Включен ли механизм раннего доступа для объявления **/
  isEarlyAccessEnabled?: TFavoriteEntityForDesktop_IsEarlyAccessEnabled;
  /** Динамический коллтрекинг для объявлений новостроек. Только для объявлений от застройщика. **/
  newbuildingDynamicCalltracking?: TFavoriteEntityForDesktop_NewbuildingDynamicCalltracking;
}

export enum EEntityType {
  /** Жилая **/
  'Residential' = 'residential',
  /** Загородка **/
  'Suburban' = 'suburban',
  /** Коммерческая **/
  'Commercial' = 'commercial',
  /** ЖК **/
  'Newbuilding' = 'newbuilding',
}
export enum EDealType {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}
export type TFavoriteEntityForDesktop_EntityCianId = null | number;

export type TFavoriteEntityForDesktop_Status = null | EStatus;

export enum EStatus {
  /** Черновик **/
  'Draft' = 'draft',
  /** Опубликовано **/
  'Published' = 'published',
  /** Деактивировано **/
  'Deactivated' = 'deactivated',
  /** Отклонено **/
  'Refused' = 'refused',
  /** Удалено **/
  'Deleted' = 'deleted',
  /** Продано **/
  'Sold' = 'sold',
  /** Промодерировано **/
  'Moderate' = 'moderate',
  /** Удалено модератором **/
  'RemovedByModerator' = 'removedByModerator',
  /** Заблокировано **/
  'Blocked' = 'blocked',
  /** Новый, создан пользователем **/
  'New' = 'new',
  /** Склеен с другим ЖК **/
  'Merge' = 'merge',
}
export type TFavoriteEntityForDesktop_PhotoFullUrl = null | string;

export type TFavoriteEntityForDesktop_PhotoPreviewUrl = null | string;

export type TFavoriteEntityForDesktop_Description = null | string;

export type TFavoriteEntityForDesktop_DeleteDate = null | string;

export type TFavoriteEntityForDesktop_Phone = null | string;

export type TFavoriteEntityForDesktop_CategoryComplaintId = null | number;

export type TFavoriteEntityForDesktop_Note = null | string;

export type TFavoriteEntityForDesktop_ComparisonStatus = null | IComparisonStatusInfo;

export type TFavoriteEntityForDesktop_AgentInfo = null | IAgent;

export type TFavoriteEntityForDesktop_FlatInfo = null | IFlatInfo;

export type TFavoriteEntityForDesktop_SuburbanInfo = null | ISuburbanInfo;

export type TFavoriteEntityForDesktop_CommercialInfo = null | ICommercialInfo;

export type TFavoriteEntityForDesktop_JkInfo = null | IJKInfo;

export type TFavoriteEntityForDesktop_IsRosreestrCheckSuccess = null | boolean;

export type TFavoriteEntityForDesktop_ShowWarningMessage = null | boolean;

export type TFavoriteEntityForDesktop_ModerationInfo = null | IModerationInfoForDesktop;

export type TFavoriteEntityForDesktop_CommercialOwnership = null | ICommercialOwnership;

export type TFavoriteEntityForDesktop_CommunicationType = null | ECommunicationType;

export enum ECommunicationType {
  /** По телефону **/
  'Phone' = 'phone',
  /** С помощью анкет **/
  'Forms' = 'forms',
}
export type TFavoriteEntityForDesktop_TitleForMobileSite = null | string;

export type TFavoriteEntityForDesktop_IsCianPartner = null | boolean;

export type TFavoriteEntityForDesktop_ExternalOfferUrl = null | string;

export type TFavoriteEntityForDesktop_TradingLink = null | string;

export type TFavoriteEntityForDesktop_Dailyrent = null | IExtendedData1;

export type TFavoriteEntityForDesktop_IsBookedFromDeveloper = null | boolean;

export type TFavoriteEntityForDesktop_IsFromSeller = null | boolean;

export type TFavoriteEntityForDesktop_IsEarlyAccessEnabled = null | boolean;

export type TFavoriteEntityForDesktop_NewbuildingDynamicCalltracking = null | INewbuildingDynamicCalltracking;
